/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Attachment,
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface MessageCreateRequest
 */
export interface MessageCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageCreateRequest
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof MessageCreateRequest
     */
    direction: MessageCreateRequestDirectionEnum;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof MessageCreateRequest
     */
    attachments: Array<Attachment>;
}

/**
* @export
* @enum {string}
*/
export enum MessageCreateRequestDirectionEnum {
    Applicant = 'from_applicant',
    ApplicantToOffice = 'from_applicant_to_office'
}

export function MessageCreateRequestFromJSON(json: any): MessageCreateRequest {
    return MessageCreateRequestFromJSONTyped(json, false);
}

export function MessageCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'body': json['body'],
        'direction': json['direction'],
        'attachments': ((json['attachments'] as Array<any>).map(AttachmentFromJSON)),
    };
}

export function MessageCreateRequestToJSON(value?: MessageCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'body': value.body,
        'direction': value.direction,
        'attachments': ((value.attachments as Array<any>).map(AttachmentToJSON)),
    };
}


